import React from "react";
import { Route } from "react-router-dom";
import {
    PaymentProgramDetailsDrawer,
    CaseMetaInfo,
    PayProCaseTaskNotes
} from "templates";

export default class PaymentProgramDetailsWrapper extends React.Component {
    render() {
        const { props } = this;
        return (
            <PaymentProgramDetailsDrawer {...props}>
                <Route
                    path={"/app/:pageID"}
                    render={(props) => <PayProCaseTaskNotes {...props} />}
                />
                <Route
                    path={"/app/:pageID"}
                    render={(props) => <CaseMetaInfo {...props} />}
                />
            </PaymentProgramDetailsDrawer>
        );
    }
}